<template>
  <div
    style=" min-width: 1200px;min-height: 1000px;height: 100%;display: block;"
  >
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleSelect"
      background-color="#0a396f"
      text-color="#fff"
      active-text-color="#ffba00"
      :style="{ left: isleft }"
    >
      <el-menu-item
        index="0"
        style="width: 500px;margin: auto;"
        disabled="disabled"
      >
        <!-- <img src="../assets/xf/logo3.png" /> -->
      </el-menu-item>
      <el-menu-item index="1"> 首页</el-menu-item>
      <el-menu-item index="2">营销工具</el-menu-item>
      <el-menu-item index="3">技术与服务</el-menu-item>
      <el-menu-item index="4">合作伙伴</el-menu-item>
      <el-menu-item index="5">关于我们</el-menu-item>
    </el-menu>
    <el-carousel
      :interval="5000"
      arrow="always"
      class="d_jump"
      :height="bannerHeight + 'px'"
      id="1"
    >
      <el-carousel-item v-for="item in imgList" :key="item.id">
        <h3>
          <img
            ref="imgHeight"
            :src="item.idView"
            class="banner_img"
            style="width: 100%;height:inherit"
          />
        </h3>
      </el-carousel-item>
    </el-carousel>
    <div id="2" class="market-tool">
      <div style="margin: auto;width: 60%">
        <h1>Marketing Tools</h1>
        <h2>营销工具</h2>
        <hr
          align="center"
          width="48px"
          color="#3b97ff"
          SIZE="2"
          noShade
          style="margin:auto"
        />
        <img
          src="../assets/xf/xian.png"
          style="margin: auto;z-index: 9;display: flex"
        />
      </div>
      <market-i-m-g></market-i-m-g>
    </div>
    <div id="3" class="market-tool service-system">
      <div style="margin: auto;width: 60%">
        <h1 style="color: #28345a;padding-top: 80px">
          Technical Service System
        </h1>
        <h2 style="color: #192650">技术服务体系</h2>
        <hr
          align="center"
          width="48px"
          color="#3b97ff"
          SIZE="2"
          noShade
          style="margin:auto"
        />
        <img
          src="../assets/xf/xian2.png"
          style="margin: auto;z-index: 9;display: flex"
        />
      </div>
      <img
        src="../assets/xf/tu.png"
        style="margin: auto;display: flex;width: 40%;"
      />
    </div>
    <div id="4" class="market-tool" style="background: none">
      <div style="margin: auto;width: 60%">
        <h1 style="color: #28345a;padding-top: 80px">Cooperative Partner</h1>
        <h2 style="color: #192650">合作伙伴</h2>
        <hr
          align="center"
          width="48px"
          color="#3b97ff"
          SIZE="2"
          noShade
          style="margin:auto"
        />
        <img
          src="../assets/xf/xian2.png"
          style="margin: auto;z-index: 9;display: flex"
        />
      </div>
      <partner-img></partner-img>
    </div>
    <div id="5" class="market-tool" style="background: #fafafb">
      <div style="margin: auto;width: 60%">
        <h1 style="color: #28345a;padding-top: 80px">About Us</h1>
        <h2 style="color: #192650">关于我们</h2>
        <hr
          align="center"
          width="48px"
          color="#3b97ff"
          SIZE="2"
          noShade
          style="margin:auto"
        />
        <img
          src="../assets/xf/xian2.png"
          style="margin: auto;z-index: 9;display: flex"
        />
      </div>
      <div class="join-word">
        广州众业技术服务有限公司于2019年成立，为广大中小型企业用户量身定做全面的移动营销服务方案，
        整合核心优质资源，服务客户发展需求。具备专业化、责任感、执行力的高素质团队，集合电信网络、数据通信、移动通信、网络集成、营销管理等各方面经验丰富的专业人才，
        致力于为客户提供完善的效果营销解决方案。
      </div>
      <button class="join-btn" @click="toRecruit">加入我们</button>
      <div class="join-box">
        <div class="join-detail">
          <img
            src="../assets/xf/dizhi.png"
            style="margin-top: 15px;margin-bottom: 15px"
          />
          <h4>公司地址</h4>
          <h5>广州市天河区天河北路30号西1009</h5>
        </div>
        <div class="join-detail">
          <img src="../assets/xf/dianhua.png" />
          <h4>联系电话</h4>
          <h5>020-85653686</h5>
        </div>
        <div class="join-detail">
          <img src="../assets/xf/youxiang.png" />
          <h4>渠道合作</h4>
          <h5>ligl@ibaybay.cn</h5>
        </div>
      </div>
    </div>
    <img
      src="../assets/xf/ditu.png"
      style="display:block;width: 100%;margin: 0"
    />
    <div class="bottom-word">
      <a href="https://beian.miit.gov.cn">
        奥ICP备2023082029号-2,Copyright2018广州众业技术服务有限公司&copy版权所有
      </a>
    </div>
  </div>
</template>

<script>
import marketIMG from "./components/marketIMG";
import partnerImg from "./components/partnerImg";

export default {
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      imgList: [
        { id: 0, idView: require("../assets/xf/banner1.jpg") },
        { id: 1, name: "详情", idView: require("../assets/xf/banner2.jpg") },
        { id: 2, name: "推荐", idView: require("../assets/xf/banner3.jpg") }
      ],
      bannerHeight: "",
      isleft: ""
    };
  },
  methods: {
    goURl(url) {
      window.location.href = url;
    },
    handleSelect(key, keyPath) {
      document.getElementById(key).scrollIntoView();
    },
    setSize: function() {
      /* this.bannerHeight = 1135 / 2560 * document.documentElement.clientWidth;
         if (this.bannerHeight > 930) this.bannerHeight = 930;
         if (this.bannerHeight < 360) this.bannerHeight = 360;*/
      var bannerHeightTest =
        document.documentElement.clientHeight /
        document.documentElement.clientWidth;
      if (bannerHeightTest > 1.3) {
        this.bannerHeight = 450;
      } else if (bannerHeightTest < 1.3) {
        this.bannerHeight = window.innerHeight - 100;
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var scrollTest = 500;

      if (scrollTop < scrollTest) {
        this.activeIndex = "1";
        this.activeIndex2 = "1";
      } else if (scrollTop > scrollTest && scrollTop < scrollTest * 2) {
        this.activeIndex = "2";
        this.activeIndex2 = "2";
      } else if (scrollTop > scrollTest * 2 && scrollTop < scrollTest * 3) {
        this.activeIndex = "3";
        this.activeIndex2 = "3";
      } else if (scrollTop > scrollTest * 3 && scrollTop < scrollTest * 4.5) {
        this.activeIndex = "4";
        this.activeIndex2 = "4";
      } else if (scrollTop > scrollTest * 4.5 && scrollTop < scrollTest * 5) {
        this.activeIndex = "5";
        this.activeIndex2 = "5";
      }
      var top_left = -Math.max(
        document.body.scrollLeft,
        document.documentElement.scrollLeft
      );
      this.isleft = top_left + "px";
    },
    toRecruit: function() {
      this.$router.push("/recruit");
    }
  },
  mounted() {
    this.setSize();
    window.addEventListener("scroll", this.handleScroll);
    document.body.addEventListener("touchstart", function() {});
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll); // 离开页面 关闭监听 不然会报错
  },
  components: {
    marketIMG,
    partnerImg
  }
};
</script>

<style scoped>
@font-face {
  font-family: SourceHanSansCN-Regular;
  src: url("../styles/SourceHanSansCN-Regular.ttf");
}

@font-face {
  font-family: SourceHanSansCN-Bold;
  src: url("../styles/SourceHanSansCN-Bold.ttf");
}

.market-tool {
  width: 100%;
  min-height: 700px;
  background: url("../assets/xf/bg.png") no-repeat;
  background-size: cover;
  margin-top: 0;
}

.service-system {
  background: url("../assets/xf/bg3.png") no-repeat;
}

h1 {
  font-family: SourceHanSansCN-Regular;
  font-size: 20px;
  color: #fff;
  opacity: 0.8;
  padding-top: 80px;
  text-align: center;
  margin-top: 0;
}

h2 {
  font-family: SourceHanSansCN-Bold;
  font-size: 24px;
  color: #fff;
  line-height: 30px;
  text-align: center;
  margin-bottom: 10px;
  margin-top: 0;
}

h3 {
  font-family: SourceHanSansCN-Regular;
  font-size: 40px;
  color: #192650;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 0;
}

.join-word {
  margin-top: 50px;
  width: 70%;
  margin-left: 15%;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #153158;
  text-align: left;
  line-height: 25px;
  letter-spacing: 1px;
}

.join-btn {
  width: 20%;
  margin-top: 50px;
  height: 60px;
  background: #0e79f1;
  border: none;
  border-radius: 30px;
  font-family: SourceHanSansCN-Bold;
  font-size: 18px;
  color: #fff;
  text-align: center;
  line-height: 60px;
  cursor: pointer;
  outline: none;
}

.join-box {
  display: flex;
  flex-direction: row;
  width: 70%;
  margin-left: 15%;
  margin-top: 40px;
  justify-content: space-between;
  margin-bottom: 20px;
}

.join-detail {
  width: 30%;
  display: flex;
  flex-direction: column;
}

.join-detail img {
  width: 65px;
  height: 65px;
  margin: auto;
}

h4 {
  font-family: SourceHanSansCN-Bold;
  font-size: 14px;
  color: #253158;
  text-align: center;
  line-height: 20px;
}

h5 {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #253158;
  text-align: center;
  margin-top: 0;
}

.bottom-word {
  display: block;
  width: 100%;
  height: 100px;
  line-height: 100px;
  background: #383838;
}
.bottom-word a {
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  color: #fafafb;
  text-decoration: none;
}

.bottom-word a:hover {
  color: #fafafb !important;
}
</style>
<style>
.el-menu-demo {
  position: fixed;
  top: 0;
  z-index: 100;
  width: 100%;
  min-width: 1200px;
}

.el-menu-demo:focus {
  outline: none;
}

li.el-menu-item {
  outline: none;
}

.el-menu-item.is-disabled {
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue